export const handleValidadeError = (msgError: string) => {
    switch (msgError) {
        case 'Não conseguimos encontrar o veiculo, por favor nos informe os dados.':
            return true;
        case 'excecao_fallback_integracao_infocar':
            return true;
        case 'Consulta Infocar Desativada':
            return true;
        default:
            return false;
    }
}

export const isVehicleTypeMismatchMessage = (msgError: string) => /tipo (do|de) ve[ií]culo/i.test(msgError ?? '');